import { render } from "./CopyrightFooter.vue?vue&type=template&id=056eb590"
import script from "./CopyrightFooter.vue?vue&type=script&lang=js"
export * from "./CopyrightFooter.vue?vue&type=script&lang=js"

import "./CopyrightFooter.vue?vue&type=style&index=0&id=056eb590&lang=css"
script.render = render

export default script